export default {
  data() {
    return {
      productEmail: '',
      lockEmail: false,
      productSend: false,
      elements: this.$store.getters.store.eshop.elements.filter(
        (e) =>
          e.page == this.$store.getters.store.eshop.layout.item ||
          e.page == "item"
      ),
    }
  },
  mounted() {
    this.$nuxt.$on('quantityUp', _ => {
      this.increase();
    })
    this.$nuxt.$on('quantityDown', _ => {
      this.decrease();
    })
    this.$nuxt.$on('addToCart', _ => {
      this.$hyperCart.addToCart(this.item)
    })
    this.$nuxt.$on('updateItem', v => {
      this.item = v
    })
  },
  watch: {
    // '$store.state.item': function (v) {
    //   this.item = this.$store.getters.item;
    // }
  },
  methods: {
    increase() {
      this.item.quantity++;
      this.$store.commit('item', this.item)
    },
    decrease() {
      if (this.item.quantity == 1) {
        return;
      }
      this.item.quantity--;
      this.$store.commit('item', this.item)
    },
  }
}
